export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "登入",
    "login.form.hint.user": "登入",
    "login.form.hint.password": "密碼",
    "login.form.checkbox.remember-me": "記住我",
    "login.form.button.sign-in": "登入",
    "login.form.message.invalid-user-credentials": "登入或密碼不正確",
    "login.form.message.account-temporarily-locked": "您的帳戶暫時遭到鎖定，請在 5 分鐘後重試",
    "login.form.message.user-required": "輸入登入",
    "login.form.message.password-required": "輸入密碼",
    "login.form.button.forgot-password": "忘記密碼?",
    "error.mfa-required.title": "設定 2FA",
    "error.mfa-required.message1": "需要使用雙因素驗證 (2FA) 來保護帳戶。",
    "error.mfa-required.message2": "系統將重新導向至線上儀表板中的帳戶設定。啟用雙因素驗證 (2FA)、依照設定指示完成設定，然後返回此處。",
    "error.mfa-required.learnMore": "進一步瞭解雙因素驗證 (2FA)",
    "error.mfa-required.continue": "繼續",
    "error.root-admin-login.title": "錯誤 403 – 禁止",
    "error.root-admin-login.message": "您以唯讀系統管理員的身分登入。若要存取 Web Recovery 主控台，請改以客戶租用戶使用者或系統管理員的身分登入",
    "error.server-busy.message": "伺服器忙碌中，請稍候再試。",
    "error.network-connection.title": "網路連線錯誤",
    "error.network-connection.message": "請檢查您的網際網路連線並再試一次。",
    "error.internal-server-error.title": "內部伺服器錯誤",
    "error.internal-server-error.message": "要解析錯誤，帶著錯誤詳細資訊聯絡支援人員：",
    "error.internal-server-error.copy.button": "複印"
};
